export default {
  fraud: {
    fraud: "Gian lận",
    map: "Bản đồ",
    caseSummary: "Case Summary",
    workflow: "Workflow",
    caseDetail: "Case Detail",
    networkInformation: "Network Information",
    investigationWorkbench: "Investigation Workbench",
    investigationHistory: "Investigation History",
  }
};
